import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { GlobalProvider } from "./context/GlobalContext";
import AppWrapper from "./App";
import "./i18n";
import store from "./store";
import "./index.scss";

const RootApp = () => {
	return (
		<GlobalProvider>
			<Provider store={store}>
				<AppWrapper />
			</Provider>
		</GlobalProvider>
	);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootApp />);
